module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_SKU2.0043.png.266a223e.jpg";